import { format, parseISO } from 'date-fns';
import React from 'react';
import styled from 'styled-components';
import { Border, Breakpoints, Color, Grid } from '../../../app/StyleGuide';
import { createCurriculum } from '../../../hooks/useCurriculum';
import { BrandCode } from '../../curriculum';
import CurriculumCoverImage from './CurriculumCoverImage';

const CurrentSubscriptionImage = styled(CurriculumCoverImage)`
  border-radius: ${Border.radius};
  width: 150px;
`;

const Container = styled.div``;

const MainContent = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  gap: ${Grid._4};
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${Grid._4};
`;

const TextContainer = styled.div`
  p {
    margin: 0;
  }

  h2 {
    margin: 0;
  }

  span {
    display: none;
    color: ${Color.Gray._70};

    @media (max-width: ${Breakpoints.screen_sm}) {
      display: block;
    }
  }
`;

const ExpiresText = styled.div`
  color: ${Color.Gray._70};

  @media (max-width: ${Breakpoints.screen_sm}) {
    display: none;
  }
`;

export default function CurrentSubscriptionCard({
  brandName,
  curriculumName,
  expires,
  brandCode,
}: {
  brandName: string;
  curriculumName: string;
  expires: string;
  brandCode: BrandCode;
}) {
  const curriculumBranding = createCurriculum(brandCode as BrandCode)?.brand;

  return (
    <Container>
      <MainContent>
        <ContentWrapper>
          {curriculumBranding && (
            <CurrentSubscriptionImage
              brand={{ background: curriculumBranding.background, logo: curriculumBranding.logo as React.ReactElement }}
            />
          )}
          <TextContainer>
            <p>{brandName}</p>
            <h2>{curriculumName}</h2>
          </TextContainer>
        </ContentWrapper>
        {expires && (
          <ExpiresText>
            <span>{`Expires: `}</span>
            <span>{format(parseISO(expires), 'MMM d, yyyy')}</span>
          </ExpiresText>
        )}
      </MainContent>
    </Container>
  );
}
